import { render, staticRenderFns } from "./TheNotificationsMenu.vue?vue&type=template&id=00a1c522&scoped=true"
import script from "./TheNotificationsMenu.vue?vue&type=script&lang=js"
export * from "./TheNotificationsMenu.vue?vue&type=script&lang=js"
import style0 from "./TheNotificationsMenu.vue?vue&type=style&index=0&id=00a1c522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a1c522",
  null
  
)

export default component.exports